export const eLetterParamsGP: (Submodule: any) => string[] = submodule => {
  let eLetterParamsArray: string[] = []

  //==================================================================//
  //==================================================================//
  //================SUPPLIER & HEADER LEVEL PARAMETERS================//
  //==================================================================//
  //==================================================================//
  const commonSupplierParams: string[] = [
    '[SupplierName]',
    '[SupplierRegNo]',
    '[SupplierPhoneNo]',
    '[SupplierAddress]',
    '[SupplierSSTRegNo]',
    '[SupplierGSTRegNo]',
    '[SupplierContactName]',
    '[SupplierContactNo]',
    '[SupplierContactEmail]',
  ]
  const commonHeaderParams: string[] = [
    '[DocumentNo]',
    '[DocumentDate]',

    // PO,GRN,GRTN
    ...(['PURCHASE_ORDER', 'GOOD_RECEIVE_NOTE', 'GOOD_RETURN_NOTE'].includes(
      submodule
    )
      ? ['[Description]']
      : []),

    // [DeliveryLocation] / [ReturnLocation]
    ...(['GOOD_RETURN_NOTE'].includes(submodule)
      ? ['[ReturnLocation]']
      : ['[DeliveryLocation]', '[DeliveryAddress]']),

    // [DeliveryDate] / [DODate] / [ReturnDate]
    ['GOOD_RETURN_NOTE'].includes(submodule)
      ? '[ReturnDate]'
      : ['GOOD_RECEIVE_NOTE'].includes(submodule)
      ? '[DODate]'
      : '[DeliveryDate]',

    // [SpecialInstruction] / [Justification]
    ...(['PURCHASE_ORDER', 'GENERATE_PO_FROM_PR'].includes(submodule)
      ? ['[ContactPerson]', '[ContactNo]', '[SpecialInstruction]']
      : ['PURCHASE_REQUISITION'].includes(submodule)
      ? ['[Justification]']
      : []),
  ]

  //=====================================================//
  //=====================================================//
  //================ITEM LEVEL PARAMETERS================//
  //=====================================================//
  //=====================================================//
  //>>>>> PO ITEM PARAMS ( GENERATE PR FROM PR; DIRECT PO; CENTRALISED PO) <<<<<//
  const poItemLevelParams: string[] = [
    '[Index]',
    ['GENERATE_PO_FROM_PR'].includes(submodule) ? '[ItemPRNo]' : null,
    '[ItemDescription]',
    '[ItemRemark]',
    '[Department]',
    '[DeptCd]',
    '[DeptCtNm]',
    '[DeptCtCd]',
    '[UOM]',
    '[Quantity]',
    '[UnitPrice]',
    '[BaseAmt]',
    '[TaxAmt]',
    '[TotalAmt]',
    '[TaxCode]',
    '[TaxRate]',
    '[PRRequestedBy]',
  ]
  //>>>>> PR ITEM PARAMS <<<<<//
  const prItemLevelParams: string[] = [
    '[Index]',
    '[ItemDescription]',
    '[ItemRemark]',
    '[Department]',
    '[DeptCd]',
    '[DeptCtNm]',
    '[DeptCtCd]',
    '[UOM]',
    '[Quantity]',
    '[UnitCost]',
    '[TotalUnitCost]',
  ]
  //>>>>> GRN ITEM PARAMS <<<<<//
  const grnItemLevelParams: string[] = [
    '[PONo]',
    '[ItemRemark]',
    '[Warehouse]',
    '[UOM]',
    '[OrderQty]',
    '[ReceivedQty]',
    '[ReceivedAmt]',
  ]
  //>>>>> GRTN ITEM PARAMS <<<<<//
  const grtnItemLevelParams: string[] = [
    '[GRNNo]',
    '[ItemDescription]',
    '[ItemRemark]',
    '[Warehouse]',
    '[UOM]',
    '[ReceivedQty]',
    '[ReturnedQty]',
    '[ReturnedAmt]',
  ]

  //========================================================//
  //========================================================//
  //================SUMMARY LEVEL PARAMETERS================//
  //========================================================//
  //========================================================//
  //>>>>> PO SUMMARY <<<<<//
  const poSummary: string[] = [
    '[SumBaseAmt]',
    '[SumTaxAmt]',
    '[SumTotalAmt]',
    '[SumTotalAmtWords]',
  ]
  //>>>>> PR SUMMARY <<<<<//
  const prSummary: string[] = ['[SumAllocationAmt]', '[SumAllocationAmtWord]']
  //>>>>> GRN SUMMARY <<<<<//
  const grnSummary: string[] = [
    '[SumOrderQty]',
    '[SumReceivedQty]',
    '[SumReceivedAmt]',
  ]
  //>>>>> GRTN SUMMARY <<<<<//
  const grtnSummary: string[] = [
    '[SumReceivedQty]',
    '[SumReturnedQty]',
    '[SumReturnedAmt]',
  ]

  //===============================================//
  //===============================================//
  //================RETURN FUNCTION================//
  //===============================================//
  //===============================================//
  switch (submodule) {
    case 'GENERATE_PO_FROM_PR':
    case 'PURCHASE_ORDER':
      return (eLetterParamsArray = [
        // Supplier Info
        ...commonSupplierParams,

        // Header Params
        ...commonHeaderParams,
        '[CreditTerm]',

        // Item Level Params
        ...poItemLevelParams,

        // Summary Level Params
        ...poSummary,
      ])

    case 'PURCHASE_REQUISITION':
      return (eLetterParamsArray = [
        // Supplier Info
        ...commonSupplierParams,

        // Header Params
        ...commonHeaderParams,
        '[RequestedBy]',
        '[ContactPerson]',

        // Item Level Params
        ...prItemLevelParams,

        // Summary Level Params
        ...prSummary,
      ])

    case 'GOOD_RECEIVE_NOTE':
      return (eLetterParamsArray = [
        // Supplier Info
        ...commonSupplierParams,

        // Header Params
        ...commonHeaderParams,

        // Item Level Params
        ...grnItemLevelParams,

        // Summary Level Params
        ...grnSummary,
      ])

    case 'GOOD_RETURN_NOTE':
      return (eLetterParamsArray = [
        // Supplier Level
        ...commonSupplierParams,

        // Header Level Params
        ...commonHeaderParams,

        // Item Level Params
        ...grtnItemLevelParams,

        // Summary Level Params
        ...grtnSummary,
      ])
  }
}
